import actions from './actions.js';

const state = {
  data: {}
}

const mutations = {
  setData(state, data) {
    state.data = { ...data };
  }
}

export default {
  state,
  mutations,
  actions,
  namespaced: true
}